import { Injectable } from '@angular/core';
import { GeneralShape } from './shapes/general/general-shape';
import { Container } from 'pixi.js';
import { RectangleController } from '../../elements/util/rectangle-controller/rectangle-controller';
import {
  _screenX,
  _screenY,
  CanvasService,
} from '../../services/canvas/canvas.service';
import {
  IndividualRectangleShape,
  RectangleShape,
} from './shapes/base/rectangle/rectangle-shape';
import { PathShape } from './shapes/path-shape/path-shape';
import {
  _Scale,
  CircleShapeDescriptor,
  Coords,
  GeneralShapeDescriptor,
  ImportedShapeDescriptor,
  PathShapeDescriptor,
  Translate,
  RectangleShapeDescriptor,
  Scale,
  ShapeConfig,
  ShapeDragParams,
  TextShapeDescriptor,
  HandShapeNewDescriptor,
  BBox,
  CommentShapeDescriptor,
  AnimationItem,
} from '../../elements/resource/types/shape.type';
import { CircleShape } from './shapes/base/circle-shape';
import {
  Relationships,
  ResourceData,
} from '../../elements/resource/resource.types';
import { cloneDeep, set as _set } from 'lodash';
import * as uuidv1 from 'uuid/v1';
import { Store } from '@ngrx/store';
import {
  scenesAreLoaded,
  selectFontLoaded,
  selectIsFileLoading,
  selectNoAnimationMode,
  selectShapes,
  getCurrentFile,
  selectFiles,
  selectAbsoluteCellAlignments,
} from '../store/selector/editor.selector';
import {
  addNewShapeAction,
  bulkUpdateFinish,
  incrementRadius,
  loadFileAction,
  openFile,
  resetBaseState,
  createNewComponentAction,
  setSelectedShapes,
  setChangeTookPlace,
  setPreviewShapeLoading,
  removeContainerMenuItem,
  clearContainerMenu,
} from '../store/editor.actions';
import {
  deleteShapeAction,
  setDescriptorValue,
} from '../store/editor.crud.actions';
import { RootShape } from './shapes/general/root/root-shape';
import { GroupShape } from './shapes/group/group-shape';
import { ImportedShape } from './shapes/general/imported/imported-shape';
import { ImageShape } from './shapes/base/image-shape';
import { TrajectoryShape } from './shapes/trajectory/trajectory-shape';
import { ShadowShape } from './shapes/path-shape/shadow/shadow-shape';
import { TextShape } from './shapes/text/text-shape';
import { AnimationService } from '../animation/animation.service';
import { Resource } from '../../elements/resource/resource';
import { OrientationService } from '../../services/orientation/orientation.service';
import { selectCurrentAnimationId } from '../animation/store/animation.selector';
import { addAnimationItemAction } from '../animation/store/animation.actions';
import {
  getCurrentProject,
  selectCurrentScenes,
  selectFileByIRI,
} from '../../projects/project.selector';
import { Library, Project } from '../../projects/project.interface';
import { SubtitleElement } from './subtitle/subtitle-element';
import {
  setCurrentFileID,
  setLibraryValue,
  setProjectLoaded,
  stepLanguage,
} from '../../projects/project.actions';
import { currentOrganisation } from '../../organisation/organisation.selector';
import { Organisation } from '../../organisation/organisation.interface';
import { HandShape } from './shapes/path-shape/hand-shape/hand-shape';
import { LayerShape } from './shapes/layer/layer-shape';
import { filter } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';
import { IdToIRI, IRIToId } from '../../util/iri';
import {
  ArmShapeDescriptor,
  ArmShapeNext,
} from './shapes/path-shape/arm-section/arm-shape-new';
import { HandShapeNext } from './shapes/path-shape/hand-shape-next/hand-shape-next';
import { APIConfig } from '../../api/api-config.provider';
import { FontService } from '../control-panel/canvas-control-panel/text/font.service';
import { EllipseShape } from './shapes/base/ellipse/ellipse-shape';
import { CommentShape } from './shapes/base/comment/comment-shape';
import { GlowShape, GlowShapeDescriptor } from './shapes/glow/glow-shape';
import { rotate } from 'mathjs';
import { ContainerShape } from './shapes/container/container.shape';
import { PlaceholderShape } from './shapes/placeholder/placeholder-shape';

@Injectable()
export class ShapeService {
  selectorRectangle: IndividualRectangleShape;

  get rootShape() {
    return this.cs.previewShape;
  }

  get previewShape() {
    return this.cs.previewShape;
  }
  set previewShape(shape: RootShape) {
    this.cs.previewShape = shape;
  }
  get selectedShapes() {
    return Object.keys(this.selectedShapesStore)
      .map(IRI => this.resourceStore[IRI] as GeneralShape)
      .filter(shape => !!shape);
  }

  get currentScene() {
    return this.cs.currentScene;
  }

  get apiUrl(): string {
    return this.apiConfig.api.url;
  }

  lastFileData: ResourceData;
  appContainer: Container;
  previewShapeIsLoading = false;
  shapes: Record<string, ResourceData>;
  files: Record<string, ResourceData>;
  imagesToLoad: Record<string, boolean> = {};

  initRootShape(resourceData: ResourceData) {
  }

  _initRootShape(rootShape: RootShape) {
    const load = async () => {
      this.imagesToLoad = {};
      // this.resourceStore = {};
      this.selectedShapesStore = {};

      this.cs.resetImage();

      // this.lastFileData = resourceData; //

      this.imagesToLoad = {};
      // console.log('init-root-shape > RootShape instance'); //
      // this.previewShape = new RootShape(this, resourceData); //
      // this.previewShape.afterInit(); // -- //

      this.previewShape = rootShape;

      this.cs.addShapeToCanvas(this.previewShape);
      // console.log('init-root-shape > CanvasShape ready. wait for images...');
      // await this.waitForImageAndFontLoads();
      // console.log('init-root-shape > images loaded! fitting canvas...');
      await this.cs.fitCanvas();

      this.store.dispatch(setProjectLoaded({ value: true }));
      this.cs.generalEventEmit('thumbnails-loaded');
      this.store.dispatch(setPreviewShapeLoading({ value: false }));
      this.cs.generalEventEmit('fileLoaded', true);
    };

    load();
    return this.cs.previewShape;
  }

  async addImageShapeByBase64(base64: string) {
    const imageShape = this.previewShape.addImageShape(
      [_screenX / 2, _screenY / 2],
      base64,
    );
    const { error } = await this.cs.httpService.saveImageToS3(
      base64,
      IRIToId(imageShape.IRI),
      '.png',
    );
    if (error) {
      throw new Error(`Image could not be saved to S3: ${error.message}`);
    }
  }

  // async waitForImageAndFontLoads() {
  //   return new Promise<void>(res => {
  //     const interval = setInterval(async () => {
  //       const keys = Array.from(Object.keys(this.imagesToLoad));
  //       const fontKeys = Array.from(Object.keys(this.fontService.fontsToLoad));
  //       if (keys.length === 0 && fontKeys.length === 0) {
  //         clearInterval(interval);
  //         // this.cs.setThumbnail(); // -- // -- // -- //

  //         this.previewShapeIsLoading = false;

  //         this.cs.canvasContainer.visible = true;
  //         res();
  //         return;
  //       }

  //       for (const key of keys) {
  //         if (this.getShapeByIRI(key)?.texture?.baseTexture?.valid) {
  //           delete this.imagesToLoad[key];
  //         }
  //       }
  //     }, 100);
  //   });
  // }

  currentSceneRootShape: RootShape;
  visitStack = [];
  noAnimationMode: boolean;
  currentProject: Project;
  currentScenes: ResourceData[];
  currentOrganisation: Organisation;
  currentFile: ResourceData;
  constructor(
    readonly store: Store,
    readonly cs: CanvasService,
    readonly animationService: AnimationService,
    readonly orientationService: OrientationService,
    private readonly apiConfig: APIConfig,
    readonly fontService: FontService,
  ) {
    this.store.select(selectCurrentAnimationId).subscribe(id => {
      this.cs.currentAnimationID = id;
      if (!id) {
        this.animationService.selectedFrame = null;
      }
    });

    this.store.select(selectAbsoluteCellAlignments).subscribe(val => {
      // console.log('------------ selectAbsoluteCellAlignments ----------', val);
      // -- // -- //
      // this.absoluteCellAlignments = val;
      // -- // -- //
    });

    const waitForShapes = async (shapes: Record<string, boolean>) => {
      return new Promise(resolve => {
        const shapeIRIs = Object.keys(shapes || {});
        if (shapeIRIs.length == 0) {
          return resolve(true);
        }

        const [IRI] = shapeIRIs;

        if (this.shapes[IRI]) {
          return resolve(true);
        }

        let i = 0;
        const interval = setInterval(() => {
          i++;
          if (this.shapes[IRI]) {
            return resolve(true);
          }

          if (i > 10) {
            clearInterval(interval);
            resolve(false);
            return;
          }
        }, 100);
      });
    };
    combineLatest([
      this.store.select(currentOrganisation),
      this.store.select(getCurrentProject),
      this.store.select(getCurrentFile),
      this.store.select(selectFontLoaded),
      this.store.select(selectIsFileLoading),
      // this.store.select(selectCurrentShapes),
    ])
      .pipe(
        filter(
          // file will be there by project loading, isFileLoading will be true only if the shapes are loaded
          ([org, project, file, fontLoaded, isFileLoading]) => {
            // console.log('filter > file', file);
            /* console.log('filter', {
              org,
              project,
              file,
              isFileLoading,
            }); */
            return (
              !!org &&
              !!project &&
              // !!file?.relationships?.shapes &&
              !!file
              //!isFileLoading
            );
          },
        ),
      )
      .subscribe(async ([, project, file]) => {
        if (
          this.currentProject?.id === project.id &&
          this.currentFile?.IRI == file.IRI
        ) {
          return;
        }

        this.currentProject = cloneDeep(project);
        this.currentFile = file;

        this.animationService.currentProject = cloneDeep(project);

        setTimeout(() => {
          this.initRootShape(file);
        }, 1000);
      });

    this.store.select(getCurrentProject).subscribe(project => {
      // -- // -- console.log('------ currentProject -----', project); // -- // -- //
    });

    this.store.select(selectNoAnimationMode).subscribe(val => {
      this.noAnimationMode = val;
    });

    this.store.select(selectCurrentScenes).subscribe(scenes => {
      this.currentScenes = scenes.sort(
        (s1, s2) => s1.literals.sceneIndex - s2.literals.sceneIndex,
      );
    });

    this.store.select(currentOrganisation).subscribe(org => {
      this.currentOrganisation = org;
    });

    this.store.select(getCurrentProject).subscribe(project => {
      this.currentProject = project;
    });

    this.store.select(selectShapes).subscribe(shapes => {
      this.shapes = shapes;
    });

    this.store.select(selectFiles).subscribe(async files => {
      if (files === undefined) {
        return;
      } else if (this.files == files && Object.keys(files || {}).length > 0) {
        return;
      }
      this.files = files;
      await this.initProjectFiles();
    });

    this.cs.keyEventSubscribe(
      'Space+1',
      () => {
        this.cs.consumeKeyEvent('Space');
        this.store.dispatch(
          setDescriptorValue({
            key: 'show-hide',
            value: {
              value: true,
            },
          }),
        );
        this.finishShapeUpdate();
      },
      0,
    );

    this.cs.keyEventSubscribe('l+Tab', () => {
      this.cs.consumeKeyEvent('Tab');
      this.store.dispatch(stepLanguage());
    });

    this.cs.keyEventSubscribe('r+ArrowUp', () => {
      this.store.dispatch(incrementRadius({ increment: 1 }));
      this.store.dispatch(bulkUpdateFinish());
    });

    this.cs.keyEventSubscribe('r+ArrowDown', () => {
      this.store.dispatch(incrementRadius({ increment: -5 }));
      this.store.dispatch(bulkUpdateFinish());
    });

    this.cs.keyEventSubscribe('r+ArrowRight', () => {
      this.store.dispatch(incrementRadius({ increment: 5 }));
      this.store.dispatch(bulkUpdateFinish());
    });

    this.cs.keyEventSubscribe('r+ArrowLeft', () => {
      this.store.dispatch(incrementRadius({ increment: -5 }));
      this.store.dispatch(bulkUpdateFinish());
    });

    this.cs.keyEventSubscribe('s+Backspace', () => {
      console.log('s+backspace');
    });

    this.cs.generalEventSubscribe('clear-resource-store', () => {
      // this.resourceStore = {};
    });

    this.cs.generalEventSubscribe('canvasMove', ({ dx, dy }) => {
      if (this.selectedShapes.length > 1) {
        this.updateBBoxes();
      }
    });

    this.cs.generalEventSubscribe('canvasScale', ({ dx, dy }) => {
      if (this.selectedShapes.length > 1) {
        this.updateBBoxes();
      }
    });

    this.cs.generalEventSubscribe('canvas-hover', () => {
      this.hoverSelectedShapes.map(shape => shape.deselect({ onHover: true }));
    });

    this.cs.generalEventSubscribe(
      'variable-changed',
      ({ key, varName, value }) => {
        console.log('variable-changed', { key, varName, value });
        this.currentProject.library[key][varName] = value;
        this.store.dispatch(
          setLibraryValue({
            key,
            varName,
            value,
          }),
        );
        this.cs.generalEventEmit(`variable.update.${key}.${varName}`);
      },
    );

    this.cs.keyEventSubscribe('r+c', () => {
      const [is] = this.selectedShapes;
      if (is?.getType() == 'is') {
        (is as ImportedShape).addRotationCenterPC();
      }
    });

    this.cs.keyEventSubscribe('Shift+r', () => {
      this.cs.consumeKeyEvent('r');
      console.log('------ reset-base-state -------');
      this.resetBaseState();
    });

    this.cs.keyEventSubscribe('Shift+g', () => {
      this.createImportedShapeFromSelection();
    });

    this.cs.keyEventSubscribe('x+m', () => {
      this.store.dispatch(
        setDescriptorValue({
          key: 'auxMode',
          value: true,
        }),
      );
    });

    this.cs.keyEventSubscribe('f+p', () => {
      this.store.dispatch(
        setDescriptorValue({
          key: 'fixPosition',
          value: true,
        }),
      );
    });

    this.cs.keyEventSubscribe('s+i', () => {
      if (!this.previewShape) {
        return;
      }

      // this.previewShape.shapes.map((shape, index) => {
      //   shape.index = index;
      this.store.dispatch(
        setDescriptorValue({
          IRI: this.selectedShapes[0].IRI,
          key: 'index',
          value: 90,
        }),
      );
      this.store.dispatch(bulkUpdateFinish());

      // });
    });

    this.cs.keyEventSubscribe('Space+c', () => {
      this.selectedShapes
        .filter(shape => shape.getType() == 'path-shape')
        .map((ps: PathShape) => ps.flipClosed());

      this.finishShapeUpdate();
    });

    this.cs.keyEventSubscribe('Shift+ArrowUp', () => {
      this.selectedShapes.map(shape => shape.incrementIndex());
    });

    this.cs.keyEventSubscribe('Shift+ArrowDown', () => {
      this.selectedShapes.map(shape => shape.decrementIndex());
    });

    this.cs.keyEventSubscribe('Shift+p', () => {
      if (this.cs.currentAnimationID) {
        this.cs.consumeKeyEvent('a');
        this.store.dispatch(
          addAnimationItemAction({ item: { key: 'appear' } }),
        );
      }
    });

    this.cs.keyEventSubscribe('Shift+o', () => {
      if (this.cs.currentAnimationID) {
        this.cs.consumeKeyEvent('a');
        this.store.dispatch(
          addAnimationItemAction({ item: { key: 'disappear' } }),
        );
      }
    });

    this.cs.keyEventSubscribe(
      'a',
      () => {
        this.cs.consumeKeyEvent('a');
        this.previewShape.__setPreAnimationState();
      },
      1,
    );

    this.cs.keyEventSubscribe('h', () => {
      if (!this.previewShape) {
        return;
      }
      if (this.cs.currentAnimationID) {
        this.selectedShapes.map(shape => shape.addHideAnimation());
        this.finishShapeUpdate();
      }
    });

    this.cs.keyEventSubscribe(
      'Backspace',
      consume => {
        // -- // -- // -- //
        if (!this.previewShape) {
          return;
        }
        if (this.selectedShapes.length) {
          consume();
        }

        this.selectedShapes.map(shape => shape.delete());
        this.store.dispatch(setChangeTookPlace());
        this.finishShapeUpdate();
        this.hideGroupRC();
      },
      10,
    );

    this.cs.keyEventSubscribe('Space+g', () => {
      const [groupShape] = this.selectedShapes;
      if (groupShape.getType() == 'group-shape') {
        (groupShape as GroupShape).ungroup();
      }
    });

    this.cs.keyEventSubscribe('Space+v', () => {
      this.cs.consumeKeyEvent('v');
      this.verticalAlign();
      this.resetGroupRC();
    });

    this.cs.keyEventSubscribe('Space+h', () => {
      this.horizontalAlign();
      this.cs.consumeKeyEvent('h');
    });

    this.cs.keyEventSubscribe('Shift+c', () => {
      if (!!this.previewShape && this.selectedShapes.length) {
        this.cs.copiedShapes = this.selectedShapes;
        this.cs.notify('Copied');
      }
    });

    this.cs.keyEventSubscribe('l+s', () => {
      this.store.dispatch(
        loadFileAction({
          ID: this.cs.currentFileID,
          mode: 'subscene-load',
        }),
      );
    });

    this.cs.keyEventSubscribe(
      'Space',
      () => {
        if (
          this.selectedShapes?.length == 1 &&
          this.selectedShapes[0].getType() == 'path-shape'
        ) {
          (this.selectedShapes[0] as PathShape).showRC();
          this.cs.consumeKeyEvent('Space');
          console.log('----- found --- selected-shape');
        }
      },
      19,
    );

    this.cs.keyEventSubscribe(
      'Shift+Space',
      async () => {
        console.log('Shift+Space');
        // this.cs.generalEventEmit('set-overlay', {
        //   type: 'prompt',
        //   callback: val => {
        //     console.log('overlay-response', val);

        this.cs.consumeKeyEvent('Space');

        // if (val) {
        this.store.dispatch(
          loadFileAction({ ID: this.cs.currentFileID, mode: 'subscene-load' }),
        );

        // -- // -- //
        this.store.select(scenesAreLoaded).subscribe(val => {
          if (!val) {
            return;
          }
          console.log('scenesAreLoaded', val);
          console.log('init-scene-root-shapes', this.currentScenes);
          let previousScene = this.cs.previewShape;
          this.currentSceneRootShape = this.cs.previewShape;
          this.currentScenes.map(data => {
            console.log('initializing scene root-shapes', data.literals.label);
            const sceneRootShape = new RootShape(this, data);
            sceneRootShape.afterInit();
            previousScene.nextSceneIRI = sceneRootShape.IRI;
            this.cs.previewShapesByScene[data.IRI] = sceneRootShape;
            previousScene = sceneRootShape;
          });
          this.animationService.playAnimations();
        });
        //   }, -- //
        // } as OverlayConfig);
        // -- // -- // -- //
      },
      19,
    );

    this.cs.keyEventSubscribe('Shift+v', () => {
      if (!!this.previewShape && this.cs.copiedShapes?.length) {
        const newShapes = this.cs.copiedShapes.map((shape, index) => {
          shape.deselect();
          return this.previewShape.addCopiedShape(shape, {
            // shape.containerIndex is the new position,
            // index represents the number of previously added copied shapes
            // containerIndex: shape.containerIndex + 1 + index,
            containerIndex: index,
          });
        });
        this.selectedShapesStore = {};
        this.cs.notify('Pasted');
        newShapes.map(shape => shape.select({ direct: true }));
        this.previewShape.setContainerIndexes();
        if (newShapes.length == 1) {
          this.hideGroupRC();
        } else {
          this.showGroupRC();
          newShapes.map(shape => shape.hideDragControllers());
        }
      }
    });

    this.cs.keyEventSubscribe('a+x', () => {
      if (this.cs.selectedShapes.length) {
        this.cs.consumeKeyEvent('a');
        this.cs.consumeKeyEvent('x');
      }
      this.cs.selectedShapes.map(shape => {
        shape.auxMode = !shape.auxMode;
        this.store.dispatch(
          setDescriptorValue({
            IRI: shape.IRI,
            key: 'auxMode',
            value: shape.auxMode,
          }),
        );
        this.finishShapeUpdate();
      });
    });
    // this.store.select;

    // setTimeout(() => this.addGradient(), 1_500);
  }
  subtitle: SubtitleElement;
  animationState: {
    canvasPosition: Coords;
    currentScene?: string;
  } = {
    canvasPosition: [0, 0],
    currentScene: null,
  };
  rootShapes: Record<string, RootShape> = {};
  async waitforShapes() {
    if (this.shapes !== undefined) {
      return;
    }
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (this.shapes !== undefined) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  async initProjectFiles() {
    if (Object.keys(this.files || {}).length == 0) {
      return;
    }

    // -- //
    let previousScene: RootShape;
    this.currentSceneRootShape = this.cs.previewShape;

    Object.values(this.files || {})
      .sort(
        (file1, file2) => file1.literals.sceneIndex - file2.literals.sceneIndex,
      )
      .map(file => {
        // -- // -- // -- //

        if (this.rootShapes[file.IRI]) {
          return;
        }

        const rootShape = new RootShape(this, file);
        // console.log('------ new RootShape > after ---------');
        rootShape.afterInit();
        this.rootShapes[file.IRI] = rootShape;

        if (IRIToId(file.IRI) == this.cs.currentFileID) {
          this._initRootShape(rootShape);
        }

        // -- // -- //
        if (previousScene) {
          // console.log('previus-scene', previousScene);
          previousScene.nextSceneIRI = rootShape.IRI;
        }
        previousScene = rootShape;
      });

    this.store.dispatch(bulkUpdateFinish());
  }

  setAnimationState(shapeIRI: string, position: Coords) {
    this.animationState = {
      currentScene: shapeIRI,
      canvasPosition: position,
    };
  }

  addSubtitle(text: string) {
    this.subtitle = new SubtitleElement(this, text);
  }

  removeSubtitle() {
    this.subtitle?.delete();
  }

  resolveScale(scale: Scale): _Scale {
    return {
      x: this.resolveNumber(scale?.x || 1),
      y: this.resolveNumber(scale?.y || 1),
    };
  }

  resolveTranslate(translate: Translate): Translate {
    return {
      x: this.resolveNumber(translate.x) || 0,
      y: this.resolveNumber(translate.y) || 0,
      relative: translate.relative,
    };
  }

  resolveNumber(variable: number | string) {
    return this.resolveLibaryValue<number>('number', variable);
  }

  resolveLibaryValue<T>(key: keyof Library, variable: any): T {
    if (typeof variable == 'string' && variable.startsWith('$')) {
      return this.currentProject.library?.[key]?.[variable.slice(2)] as T;
    }
    return variable;
  }

  getNextSceneShape(root: RootShape) {
    // console.log('get-scene-shape > 1', root.IRI);
    // console.log('get-scene-shape > 2', root.nextSceneIRI);
    // console.log('get-scene-shape > 3', this.rootShapes);
    return this.rootShapes[root.nextSceneIRI];
  }

  resolveColor(key: string) {
    if (key?.startsWith?.('<')) {
      const formula = key.slice(1);

      if (formula.startsWith('random')) {
        const [c1, c2, c3] = formula
          .slice(7)
          .split(',')
          .map(v => v.trim());
        // console.log('random-color', c1, c2, c3.slice(0, 7));
        // const color = ColorIncrementController.getColor(c1, c2.trim(), Math.random())
        // console.log('color', color);
        const num = Math.random();

        if (num < 0.333) {
          return c1;
        }
        if (num < 0.666) {
          return c2;
        }
        return c3.slice(0, 7);
      }

      return key;
    }

    if (!key?.startsWith?.('$')) {
      return key;
    }
    const colorPalette = {
      ...(this.currentOrganisation?.colorPalette || {}),
      ...(this.currentProject?.colorPalette || {}),
    };

    if (!colorPalette) {
      console.warn('color-palette-could not be found');
    }
    return colorPalette?.[key.slice(2)];
  }

  hoverSelectedStore: Record<string, true> = {};

  get hoverSelectedShapes() {
    return Object.keys(this.hoverSelectedStore)
      .map(IRI => this.getShapeByIRI(IRI))
      .filter(shape => !!shape);
  }

  openFirstFile() {
    console.log('open-first-file');
    setTimeout(() => {
      const file = Object.entries(this.files)
        .sort(
          (file1, file2) => file1[1].literals.index - file2[1].literals.index,
        )
        .map(file => file[1])[0];

      // -- // -- //
      console.log('open-first-file', file); //
      const fileID = IRIToId(file.IRI);
      this.navigateToFile(fileID);
    }, 1_000);
  }

  openFile(fileID: string) {
    this.cs.thumbnailUpdated = false;
    this.previewShapeIsLoading = true;
    // this.cs.previewShape?.remove();

    const rootShape = this.rootShapes[IdToIRI(fileID)];
    if (!rootShape) {
      // console.warn('------ root-shape-could not be found', fileID); // -- //
      return;
    }

    this._initRootShape(rootShape);
    // setTimeout(() => {
    //   this.store.dispatch(
    //     openFile({
    //       IRI: IdToIRI(fileID),
    //     }),
    //   );
    // }, 1000);
  }

  navigateToFile(fileID?: string) {
    console.log('navigateToFile', fileID);
    this.visitStack.push(this.cs.currentFileID);
    this.cs.router.navigate([
      'organisations',
      this.cs.currentOrganisationID,
      'projects',
      this.cs.currentProjectID,
      'file',
      fileID,
    ]);
  }

  navigateToOrgIndex(mode?: 'users' | 'settings', orgId?: string) {
    this.visitStack.push(this.cs.currentFileID);
    this.cs.router.navigate(
      ['organisations', orgId || this.cs.currentOrganisationID, mode].filter(
        v => !!v,
      ),
    );
  }

  navigateToAnimation(animationId?: string) {
    this.cs.router.navigate(
      [
        'organisations',
        this.cs.currentOrganisationID,
        'projects',
        this.cs.currentProjectID,
        'file',
        this.cs.currentRootFileID,
        animationId,
      ].filter(v => !!v),
    );
  }

  goBack() {
    this.cs.router.navigate([
      'organisations',
      this.cs.currentOrganisationID,
      'projects',
      this.cs.currentProjectID,
      'file',
      IRIToId(this.currentFile.relationships.parent as string),
    ]);
  }

  hoverSelect(shape: GeneralShape) {
    if (!this.cs.isShiftPressed) {
      this.hoverDeselect(...this.hoverSelectedShapes);
    }

    this.hoverSelectedStore[shape.IRI] = true;
    shape.hoverSelect();
  }

  hoverDeselect(...shapes: GeneralShape[]) {
    shapes.map(shape => {
      delete this.hoverSelectedStore[shape.IRI];
      shape.hoverDeselect();
    });
  }

  canvasHover() {
    if (!this.cs.isShiftPressed) {
      this.hoverDeselect(...this.hoverSelectedShapes);
    }
  }

  selectedImportedShape: ImportedShape;

  select(
    shape: GeneralShape,
    { containerItem }: { containerItem?: boolean } = {},
  ) {
    if (!this.cs.isShiftPressed && !containerItem) {
      this.deselectAllShapes();
    }

    if (containerItem) {
      this.selectedShapesStore = {};
    }

    this.selectedShapesStore[shape.IRI] = true;
    // -- // -- // -- //

    if (this.selectedShapes.length > 1 && !containerItem) {
      this.selectedShapes.map(shape => shape.setMultiSelectMode());
      this.showGroupRC();
    } else {
      shape.completeSelect();
    }

    this.saveSelectedShapes();
  }

  deselect(shape: GeneralShape) {
    this.saveSelectedShapes();
  }

  deselectAllShapes() {
    // Objec
    this.selectedShapes.map(shape => shape.deselect());
    this.selectedShapesStore = {};
    this.saveSelectedShapes();
    this.hideGroupRC();
    this.store.dispatch(clearContainerMenu());
    // -- //
  }
  resetBaseState() {
    this.store.dispatch(resetBaseState());
    this.previewShape.resetBaseState();
    this.animationService.resetBaseState();
  }
  areThereSelectedShapes() {
    return this.selectedShapes.length > 0;
  }
  shapesTobeMasked: GeneralShape[];
  setShapeToBeMasked() {
    this.shapesTobeMasked = this.selectedShapes;
    // -- // -- // -- // -- //
  }
  initShape<T = GeneralShape<GeneralShapeDescriptor>>(
    data: ResourceData<GeneralShapeDescriptor>,
    parent?: GeneralShape,
    config?: ShapeConfig,
  ): T {
    if (parent) {
      _set(data, 'relationships.parent', parent.IRI);
    }
    // -- // console.log('init-shape', data); // -- //
    const type: string = (data as ResourceData).literals.descriptor.type;
    let shapeClass;
    switch (type) {
      case 'image-shape':
        shapeClass = ImageShape;
        break;

      case 'imported-shape':
        shapeClass = ImportedShape;
        break;

      case 'imported-shape-preview':
        shapeClass = ImportedShape;
        break;

      case 'trajectory-shape':
        shapeClass = TrajectoryShape;
        break;

      case 'circle-shape':
        // shapeClass = CircleShape;
        shapeClass = EllipseShape;
        break;

      case 'rectangle-shape':
        shapeClass = RectangleShape;
        break;

      case 'layer-shape':
        shapeClass = LayerShape;
        break;

      case 'shadow-shape':
        shapeClass = ShadowShape;
        break;

      case 'text-shape':
        shapeClass = TextShape;
        break;

      case 'group-shape':
        shapeClass = GroupShape;
        break;
      case 'hand-shape':
        shapeClass = HandShape;
        break;
      case 'hand-shape-next':
        shapeClass = HandShapeNext;
        break;
      case 'arm-shape':
        shapeClass = ArmShapeNext;
        break;
      case 'comment-shape':
        shapeClass = CommentShape;
        break;
      case 'container-shape':
        shapeClass = ContainerShape;
        break;
      case 'glow-shape':
        shapeClass = GlowShape;
        break;
      case 'placeholder-shape':
        shapeClass = PlaceholderShape;
        break;
      default:
        shapeClass = PathShape;
        break;
    }

    return new shapeClass(this, data, config) as T;
  }

  resourceStore: Record<string, Resource> = {};

  saveResource(resource: Resource) {
    this.resourceStore[resource.IRI] = resource;
    // console.log('save-resource', this.resourceStore); //
  }

  deleteResource(resource: Resource) {
    delete this.resourceStore[resource.IRI];
  }

  getResource(IRI: string): Resource {
    return this.resourceStore[IRI];
  }

  getShapeByIRI(IRI: string): GeneralShape {
    return this.resourceStore[IRI] as GeneralShape;
  }

  dxAvg: number;
  xStartForHorizontalAlign: number;

  dyAvg: number;
  yStartForVerticalAlign: number;

  isColumnSelection() {
    return this._isColumnSelection(this.selectedShapes);
  }
  _isColumnSelection(shapes: GeneralShape[], treshold = 3) {
    if (shapes.length < treshold) {
      return false;
    }

    this.dyAvg = 0;
    const shapesByY = shapes.sort((shape1, shape2) => shape1.y - shape2.y);
    console.log(
      { shapesByY },
      shapesByY.map(shape => shape.y),
    );

    if (shapesByY.length == 2) {
      // -- // -- // -- //
      const [shape1, shape2] = [shapesByY[0], shapesByY[1]];
      const { y, height } = shape1.getCurrentBBox();
      const shape1End = y + height;
      // console.log('is-column y', y, 'height', height, 'shape2', shape2.y);
      if (shape2.y < shape1End) {
        return false;
      }
      return true;
    }

    const diffs = {};
    for (let i = 0; i < shapesByY.length - 1; i++) {
      const [shape1, shape2] = [shapesByY[i], shapesByY[i + 1]];
      const { y, height } = shape1.getCurrentBBox();
      const shape1End = y + height;
      if (i == 0) {
        this.yStartForVerticalAlign = shape1End;
      }

      if (shape2.y < shape1End) {
        return false;
      }
      const diff = shape2.y - shape1End;
      diffs[diff.toFixed(2)] = diff;
      this.dyAvg += diff;
    }

    // console.log(diffs); // -- // -- // -- //

    if (Object.keys(diffs).length == 1) {
      this.evenGap = Object.values(diffs)[0] as number;
    }

    this.dyAvg /= shapesByY.length - 1;
    this.dyAvg = Math.floor(this.dyAvg);
    return true;
  }

  evenAlignColumn(gap?: number): number {
    const overrideMode = !!gap;

    gap ||= this.dyAvg;

    let y = this.yStartForVerticalAlign;
    this.selectedShapesByY.map((shape, index) => {
      if (index == 0) {
        return;
      }
      if (index == this.selectedShapes.length - 1 && !overrideMode) {
        return;
      }
      y += gap;
      shape.y = y;
      shape.saveTranslate();
      shape.applyTranslate({
        x: shape.x,
        y: shape.y,
      });

      y += shape.getCurrentBBox().height;
    });
    this.resetGroupRC();
    this.finishShapeUpdate();

    this.evenGap = gap;
    return gap;
  }

  get selectedShapesByY() {
    return this.selectedShapes.sort((shape1, shape2) => shape1.y - shape2.y);
  }

  get selectedShapesByX() {
    return this.selectedShapes.sort((shape1, shape2) => shape1.x - shape2.x);
  }

  isRowSelection() {
    return this._isRowSelection(this.selectedShapes);
  }

  _isRowSelection(shapes: GeneralShape[], treshold = 3) {
    if (shapes.length < treshold) {
      return false;
    }

    this.dxAvg = 0;
    const shapesByX = shapes.sort((shape1, shape2) => shape1.x - shape2.x);
    console.log(
      { shapesByX },
      shapesByX.map(shape => shape.x),
    );

    if (shapesByX.length == 2) {
      // -- // -- //
      const [shape1, shape2] = [shapesByX[0], shapesByX[1]];
      const { x, width } = shape1.getCurrentBBox();
      console.log('is-row x', x, 'width', width, 'shape2', shape2.x);
      const shape1End = x + width;
      if (shape2.x < shape1End) {
        return false;
      }
      return true;
    }

    for (let i = 0; i < shapesByX.length - 1; i++) {
      const [shape1, shape2] = [shapesByX[i], shapesByX[i + 1]];
      const { x, width } = shape1.getCurrentBBox();
      console.log('_isRow', { x, width });
      const shape1End = x + width;
      if (i == 0) {
        this.xStartForHorizontalAlign = shape1End;
      }

      if (shape2.x < shape1End) {
        return false;
      }
      const diff = shape2.x - shape1End;
      this.dxAvg += diff;
    }

    this.dxAvg /= shapesByX.length - 1;
    this.dxAvg = Math.floor(this.dxAvg);
    return true;
  }

  alignRow(type: 'left' | 'center' | 'right') {
    switch (type) {
      case 'left':
        // -- //
        break;
      case 'center':
        // -- //
        break;
      case 'right':
        // -- //

        break;
    }
  }

  evenAlignRow(gap?: number): number {
    const overrideMode = !!gap;

    gap ||= this.dxAvg;

    let x = this.xStartForHorizontalAlign;
    this.selectedShapesByX.map((shape, index) => {
      if (index == 0) {
        return;
      }
      if (index == this.selectedShapes.length - 1 && !overrideMode) {
        return;
      }
      x += gap;
      shape.x = x;
      shape.saveTranslate();
      shape.applyTranslate({
        x: shape.x,
        y: shape.y,
      });

      x += shape.getCurrentBBox().width;
    });
    this.resetGroupRC();
    this.finishShapeUpdate();
    this.evenGap = gap;
    return gap;
  }

  verticalAlign(pos: 'up' | 'center' | 'bottom' = 'center') {
    let ySum = 0;
    const shapes = this.cs.selectedShapes;
    const diffs = [];
    shapes.map(shape => {
      const { height } = shape.mainContainer.getBounds();
      const dy = height / 2;
      ySum += shape.y + dy;
      diffs.push(dy);
    });
    const mean = ySum / shapes.length;
    shapes.map((shape, i) => {
      shape.y = mean - diffs[i];
      shape.saveTranslate();
      shape.applyTranslate({
        x: shape.x,
        y: shape.y,
      });
    });
    this.finishShapeUpdate();
  }

  horizontalAlign(pos: 'left' | 'center' | 'right' = 'center') {
    let xSum = 0;
    const shapes = this.cs.selectedShapes;
    const diffs = [];
    shapes.map(shape => {
      const { width } = shape.mainContainer.getBounds();
      const dx = width / 2;
      // console.log('height', width);

      if (isNaN(+width)) {
        return;
      }

      xSum += shape.x + dx;
      diffs.push(dx);
    });
    const mean = xSum / shapes.length;
    shapes.map((shape, i) => {
      shape.x = mean - diffs[i];
      shape.saveTranslate();
      shape.redraw();
    });
    this.finishShapeUpdate();
  }

  finishShapeUpdate() {
    this.store.dispatch(bulkUpdateFinish());
  }

  concentricCircles() {
    let xSum = 0;
    let ySum = 0;
    const diffs = [];
    const shapes = this.cs.selectedShapes;
    shapes.map((shape: CircleShape) => {
      shape.makeSymmetric();
      const [ox, oy] = shape.origin;
      xSum += ox;
      ySum += oy;
    });

    const [x, y] = [xSum, ySum].map(v => v / shapes.length);
    shapes.map((shape: CircleShape) => {
      shape.origin = [x, y];
      shape.save();
      shape.redraw();
    });
  }

  setAsDarkShadow() {
    this.cs.selectedShapes.map(shape => {
      shape.patch('svgAttributes', {
        fill: '#000',
        opacity: 0.1,
        stroke: null,
      });
      // console.log('opacity', shape.opacity);
    });
  }

  setAsLightShadow() {
    this.cs.selectedShapes.map(shape => {
      shape.patch('svgAttributes', {
        fill: '#ffffff',
        opacity: 0.3,
        stroke: null,
      });
    });
  }

  dragState: 'started' | 'took-place' | 'idle' = 'idle';

  shapesToBeDragged: GeneralShape[];

  startDrag(shape?: GeneralShape) {
    this.dragState = 'started';
    if (shape instanceof RootShape) {
      this.shapesToBeDragged = this.selectedShapes;
      this.shapesToBeDragged.map(shape => shape?.startBaseDrag());
      return;
    }

    if (shape && !this.selectedShapesStore[shape.IRI]) {
      this.shapesToBeDragged = [shape];
    } else if (shape?.groupShapeParent) {
      this.shapesToBeDragged = this.selectedShapes.filter(
        _shape => _shape?.IRI !== shape.groupShapeParent.IRI,
      );
    } else {
      this.shapesToBeDragged = this.selectedShapes;
    }
    this.shapesToBeDragged.map(shape => shape?.startBaseDrag());
  }

  dx: number;
  dy: number;

  drag(dx: number, dy: number, trace?: string) {
    this.dx = 0;
    this.dy = 0;
    // this.orientationService.clearOrientationLines();
    // const {
    //   xMin: xs,
    //   yMin: ys,
    //   xMax: xe,
    //   yMax: ye,
    // } = this.getSelectedBoundingRectangle();
    // -- // -- //
    //   this.orientationService._checkHorizontal('cs', [
    //     {
    //       coords: [xs, ys],
    //       left: false,
    //     },
    //     {
    //       coords: [xs, ye],
    //       left: false,
    //     },
    //     {
    //       coords: [xe, ys],
    //       left: true,
    //     },
    //     {
    //       coords: [xe, ye],
    //       left: true,
    //     },
    //   ]);
    //   this.orientationService._checkVertical('cs', [
    //     {
    //       coords: [xs, ys],
    //       top: false,
    //     },
    //     {
    //       coords: [xe, ys],
    //       top: false,
    //     },
    //     {
    //       coords: [xs, ye],
    //       top: true,
    //     },
    //     {
    //       coords: [xe, ye],
    //       top: true,
    //     },
    //   ]);
    // console.log('dx', dx, 'dy', dy);
    this.moveAlignIcons(dx * this.cs._canvasScale, dy * this.cs._canvasScale);
    this.shapesToBeDragged.map(shape => shape?.drag(dx, dy));

    if (this.shapesToBeDragged.length > 1) {
      const { x, y } = this.multiShapeSelectRCAbsoluteBBox;
      this.currentMultiSelectRCAbsoluteBBox.x =
        this.multiShapeSelectRCAbsoluteBBox.x + dx;
      this.currentMultiSelectRCAbsoluteBBox.y =
        this.multiShapeSelectRCAbsoluteBBox.y + dy;
      this.groupRC.patch(
        {
          offset: [x + dx, y + dy],
        },
        true,
      );
    }
  }

  endDrag(_params?: ShapeDragParams) {
    // console.log('------service. end-drag------');
    this.dragState = 'idle';
    this.shapesToBeDragged.map(shape => shape.endDrag());

    this.store.dispatch(bulkUpdateFinish());

    this.updateBBoxes();
  }
  moveAlignIcons(dx: number, dy: number, accumulate = false) {
    // this.multiShapeSelectRCRelativeBBox.x
  }

  addTrajectoryAppearAnimation() {
    // this.cs.selectedShapes
    //   .filter(shape => shape.getType() == 'ps')
    //   .map((ps: PathShape) => {
    //     ps.addAnimation('trajectory-appear', null);
    //     ps.save();
    //   });
  }

  startSelectorRectangle(x: number, y: number) {
    if (!this.cs.previewShape) {
      return;
    }
    if (this.selectorRectangle) {
      this.cs.app.stage.removeChild(this.selectorRectangle.container);
    }

    this.selectorRectangle?.remove();
    this.selectorRectangle = new IndividualRectangleShape(this, {
      position: { x, y },
      width: 0,
      height: 0,
      svgAttributes: {
        stroke: { color: '#000000', width: 1 },
      },
    });
    this.cs.addToCanvas(this.selectorRectangle);
  }

  selectorWidth = 0;
  selectorHeight = 0;
  strict = false;

  dragSelectorRectangle(x: number, y: number, width: number, height: number) {
    if (!this.cs.previewShape) {
      return;
    }
    if (!this.selectorRectangle) {
      return;
    }
    this.selectorWidth = Math.abs(width);
    this.selectorHeight = Math.abs(height);
    this.strict = width < 0;
    this.selectorRectangle.x = x;
    this.selectorRectangle.y = y;
    this.selectorRectangle._redraw({ x, y });
    this.selectorRectangle?._resize(this.selectorWidth, this.selectorHeight);

    // const shapeToSelect = this.cs.previewShape.shapes.filter(shape =>
    //   shape.selection({
    //     xLimits:
    //       this.selectorWidth > 0
    //         ? [x, x + this.selectorWidth]
    //         : [x + this.selectorWidth, x],
    //     yLimits:
    //       this.selectorHeight > 0
    //         ? [y, y + this.selectorHeight]
    //         : [y + this.selectorHeight, y],
    //     strict: this.strict,
    //   }),
    // );

    // const currentSelection = {};
    // shapeToSelect.map(shape => {
    //   currentSelection[shape.IRI] = shape;
    //   shape.rc?.show();
    //   // shape.rc?.hidePointControllers();
    // });

    // Object.keys(this.selectedShapesStore).map(IRI => {
    //   if (!currentSelection[IRI]) {
    //     this.getShapeByIRI(IRI)?.hideDragControllers();
    //   }
    // });

    // this.hoverSelectedShapes.map(shape => shape?.hideDragControllers());
    // this.hoverSelectedStore = {};

    // this.selectedShapesStore = currentSelection;
  }

  removeSelectorRectangle() {
    // -- // -- //
    if (!this.selectorRectangle) {
      console.log('no selector rectangle > deselectAllShapes');
      this.deselectAllShapes();
      return;
    }

    this.selectionAlignType = undefined;

    this.hideGroupRC();
    const { x, y } = this.selectorRectangle;

    /* if (!this.cs.isShiftPressed) {
      this.selectedShapes.map(shape => shape.hideDragControllers());
      this.selectedShapesStore = {};
    } */

    const selectedShapesByRectangle = this.cs.previewShape.shapes.filter(
      shape => {
        return shape.selection({
          xLimits:
            this.selectorWidth > 0
              ? [x, x + this.selectorWidth]
              : [x + this.selectorWidth, x],
          yLimits:
            this.selectorHeight > 0
              ? [y, y + this.selectorHeight]
              : [y + this.selectorHeight, y],
          strict: this.strict,
        });
      },
    );
    // .map(shapeToSelect => {
    //   this.selectedShapesStore[shapeToSelect.IRI] = true;
    // });

    console.log('selectedShapesByRectangle', selectedShapesByRectangle);

    switch (selectedShapesByRectangle.length) {
      case 0:
        // bit dirthy but becuase of the
        this.previewShape?.deselect();
        this.deselectAllShapes();
        break;
      case 1:
        selectedShapesByRectangle[0].select();
        break;
      default:
        selectedShapesByRectangle.map(shape => {
          shape.selected = true;
          shape.setMultiSelectMode();
        });
        this.showGroupRC();
        break;
    }

    this.saveSelectedShapes();

    // console.log('selectedShape', this.selectedShapes); // -- //
    this.selectorWidth = 0;
    this.selectorHeight = 0;
    this.strict = false;
    this.selectorRectangle?.remove();
    this.selectorRectangle = null;

    // this.selectionAlignType = undefined;
  }

  saveSelectedShapes() {
    this.store.dispatch(
      setSelectedShapes({ shapes: cloneDeep(this.selectedShapesStore) }),
    );
  }

  checkSelectorRectangle() {
    // -- // -- // -- //
  }

  zoomUpdate() {
    this.cs.previewShape?.zoomUpdate();
    this.selectedShapes.map(shape => shape.zoomUpdate());
    this.hoverSelectedShapes.map(shape => shape?.zoomUpdate());
    this.groupRC?.zoomUpdate();
  }

  bBoxStore: Record<string, BBox> = {};
  getBoundingRectangle(shapes: GeneralShape[]) {
    let xMin = Infinity,
      yMin = Infinity,
      xMax = -Infinity,
      yMax = -Infinity;

    this.bBoxStore = {};

    for (const shape of shapes) {
      if (!shape?.container) {
        continue;
      }
      const { x, y, width, height } = shape.getBounds();

      // -- // -- //

      this.bBoxStore[shape.IRI] = { x, y, width, height };
      if (x < xMin) xMin = x;
      if (y < yMin) yMin = y;
      if (xMax < x + width) xMax = x + width;
      if (yMax < y + height) yMax = y + height;
    }

    this._x = xMin;
    this._y = yMin;

    return {
      x: xMin,
      y: yMin,
      width: xMax - xMin,
      height: yMax - yMin,
    };
  }

  groupRC: RectangleController;
  groupRCContainer: Container;
  selectedShapesStore: Record<string, boolean> = {};
  closeAfterEndDrag = false;
  groupRCDragMode = false;
  currentMultiSelectRCAbsoluteBBox: BBox;

  showVerticalEvenSpacing = false;
  verticalSpacingPosition: Coords;
  _verticalSpacingPosition: Coords;
  showHorizontalEvenSpacing = false;
  horizontalSpacingPosition: Coords;
  _horizontalSpacingPosition: Coords;

  resetGroupRC() {
    if (!this.selectedShapes.length) {
      return;
    }
    this.hideGroupRC();
    this.showGroupRC();
  }

  selectionAlignType: 'row' | 'column' | undefined;
  evenGap: number;

  showGroupRC() {
    if (!this.groupRC) {
      // TODO: circle, RT, imported
      this.initGroupRC();
    }

    this.updateBBoxes();

    this.evenGap = undefined;

    if (this.isColumnSelection()) {
      this.selectionAlignType = 'column';
    } else if (this.isRowSelection()) {
      this.selectionAlignType = 'row';
    } else {
      this.selectionAlignType = undefined;
    }

    this.groupRC.show();

    this.currentMultiSelectRCAbsoluteBBox = cloneDeep(
      this.multiShapeSelectRCAbsoluteBBox,
    );

    return this.groupRC.patch(
      {
        offset: [
          this.multiShapeSelectRCAbsoluteBBox.x,
          this.multiShapeSelectRCAbsoluteBBox.y,
        ],
        width: this.currentMultiSelectRCAbsoluteBBox.width,
        height: this.currentMultiSelectRCAbsoluteBBox.height,
      },
      true,
    );
  }

  multiShapeSelectRCRelativeBBox: BBox;
  multiShapeSelectRCAbsoluteBBox: BBox;

  updateBBoxes() {
    const { x, y, width, height } = this.getBoundingRectangle(
      this.selectedShapes,
    );

    this.multiShapeSelectRCRelativeBBox = { x, y, width, height };
    this.multiShapeSelectRCAbsoluteBBox = {
      ...this.cs.getAbsoluteCoords(x, y),
      width: width / this.cs._canvasScale,
      height: height / this.cs._canvasScale,
    };
  }

  initGroupRC() {
    this.closeAfterEndDrag = false;
    this.groupRCContainer = new Container();
    // this.cs.app.stage.addChild(this.groupRCContainer); //
    // this.cs.previewShape.rootContainer.addChild(this.groupRCContainer); //
    this.cs.previewShape.rootContainer.addChild(this.groupRCContainer);
    this.groupRC = new RectangleController(
      this.cs.previewShape,
      {
        width: 0,
        height: 0,
        offset: [0, 0],
        selectedContainerMode: true,
        dragParams: { noShow: true },
        moveRectangle: true,
        noFill: true,
        // rectangleIndex: 0,
        startDrag: () => {
          this.groupRCDragMode = true;

          this.showHorizontalEvenSpacing = false;
          this.showVerticalEvenSpacing = false;

          this.selectionAlignType = undefined;

          const { x, y } = this.multiShapeSelectRCAbsoluteBBox;
          this.selectedShapes.forEach(shape => {
            const dx = shape.x - shape.offsetX - x;
            const dy = shape.y - shape.offsetY - y;

            shape.startTransformation(dx, dy);
            shape.hoverDeselect();
          });
        },
        drag: ({ x: dx, y: dy, width: newWidth, height: newHeight }) => {
          const { x, y, width, height } = this.multiShapeSelectRCAbsoluteBBox;
          const scaleX = newWidth / width;
          const scaleY = newHeight / height;

          this.currentMultiSelectRCAbsoluteBBox = {
            x: x + dx,
            y: y + dy,
            width: newWidth,
            height: newHeight,
          };

          this.selectedShapes.forEach(shape => {
            shape.transformation(scaleX, scaleY, dx, dy);
          });
        },
        endDrag: () => {
          this.multiShapeSelectRCAbsoluteBBox = cloneDeep(
            this.currentMultiSelectRCAbsoluteBBox,
          );
          this.selectedShapes.forEach(shape => shape.endTransformation());
          this.selectedShapes.forEach(shape => shape.setMultiSelectMode());
          this.rootShape.finishUpdate();
          this.showGroupRC();
        },
        _endDrag: () => {
          // -- // this.updateGroupRC(shape); // -- //
        },
        // _drag: (dx: number, dy: number) => {
        //   // -- // -- //
        //   this.groupRC.patch(
        //     {
        //       offset: [this._x + dx, this._y + dy],
        //     },
        //     true,
        //   );
        // },
      },
      this.rootShape.rootContainer,
      this.rootShape.rootContainer,
      // this.rootShape.circleContainer,
    );

    // this.groupRC.zoomUpdate();
  }

  _x: number;
  _y: number;

  moveGroupRc([dx, dy]: Coords) {
    this.groupRCContainer?.setTransform(this._x + dx, this._y + dy);
  }

  hideGroupRC() {
    // console.log('hide-group-rc');
    this.showHorizontalEvenSpacing = false;
    this.showVerticalEvenSpacing = false;
    this.groupRC?.hide();
  }

  isLoading = false;
  isLoadSub: Subscription;

  async addImportedShape({ IRI }: ResourceData) {
    // -- // -- //
    this.isLoading = true;

    console.log('add-imported-shape');
    this.store.dispatch(openFile({ IRI, importedShape: true }));
    this.isLoadSub = this.store
      .select(selectFileByIRI(IRI))
      .pipe(filter(data => !!data?.relationships.shapes))
      .subscribe(data => {
        const { x, y } = this.cs.getAbsoluteCoords(100, 100, true);
        // console.log('add-new-shape', data);
        this.addNewShape({
          label: `${data.literals.label}:1`,
          descriptor: {
            type: 'imported-shape',
            index: this.previewShape.getNewShapeIndex(),
            // Dirty but it will be used in the editor.request.effect
            shapeIRI: data.IRI,
            position: { x, y, scale: { x: 1, y: 1 } },
          } as ImportedShapeDescriptor,
          relationships: {
            shape: data.relationships?.shape,
            instanceOf: data.IRI,
          },
        }).select();
        this.isLoading = false;
        this.isLoadSub?.unsubscribe();
      });
  }

  addGroupShape(x: number, y: number) {
    return this.addNewShape({
      label: 'group-shape',
      descriptor: {
        type: 'group-shape',
        position: { x, y },
        if: { [this.cs.currentState]: true },
      },
    });
  }

  addArmShape(x: number, y: number) {
    return this.addNewShape({
      label: 'arm-shape',
      descriptor: {
        type: 'arm-shape',
        position: { x, y },
        if: { [this.cs.currentState]: true },
        svgAttributes: {
          fill: {
            color: '#000000',
          },
        },
        config: {
          r1: 20,
          r2: 30,
          x: 100,
          y: 120,
        },
      } as ArmShapeDescriptor,
    });
  }

  addHandShape(x: number, y: number) {
    // console.log('add > hand-shape next'); //
    return this.addNewShape({
      label: 'hand-shape-next',
      descriptor: {
        type: 'hand-shape-next',
        position: { x, y },
        if: { [this.cs.currentState]: true },
        svgAttributes: {
          fill: {
            color: '#000000',
          },
        },
        config: {
          closed: false,
          handSections: [
            {
              r: 20,
            },
            {
              x: 0,
              y: 100,
              r: 30,
            },
            {
              x: 100,
              y: 0,
              r: 30,
            },
          ],
        },
      } as HandShapeNewDescriptor,
    }) as HandShapeNext;
  }

  addRectangleShape(x: number, y: number) {
    // console.log('add-rectangle-shape', x, y); //
    return this.addNewShape<RectangleShape>({
      label: 'rectangle-shape',
      descriptor: {
        type: 'rectangle-shape',
        position: { x, y },
        svgAttributes: { stroke: { color: '#000000', width: 1 } },
        width: 0,
        height: 0,
      } as RectangleShapeDescriptor,
    });
  }

  addPlaceholderShape(index: number) {
    return this.addNewShape({
      label: 'placeholder-shape',
      descriptor: {
        position: { x: 0, y: 0 },
        type: 'placeholder-shape',
        index,
      },
    });
  }

  addCircleShape(x: number, y: number) {
    return this.addNewShape({
      label: 'circle-shape',
      descriptor: {
        type: 'circle-shape',
        position: { x, y },
        svgAttributes: { stroke: { color: '#000000', width: 1 } },
        rx: 0,
        ry: 0,
      } as CircleShapeDescriptor,
    });
  }

  addPathShape(x: number, y: number) {
    return this.addNewShape<PathShape>({
      label: 'path-shape',
      descriptor: {
        type: 'path-shape',
        position: { x, y },
        svgAttributes: { stroke: { color: '#000000', width: 1 } },
        newCurveAngle: true,
        sections: [
          {
            type: this.cs.isPressed(['s', 'd']) ? 'curve' : 'line',
            id: Math.random().toString(),
            x: 0,
            y: 0,
          },
          {
            type: 'line',
            id: Math.random().toString(),
            x: 0,
            y: 0,
          },
        ],
      } as PathShapeDescriptor,
    });
  }

  addTextShape(x: number, y: number) {
    return this.addNewShape({
      label: 'text-shape',
      descriptor: {
        type: 'text-shape',
        position: { x, y },
        svgAttributes: { fill: { color: '#000000' } },
        // TODO - clean this
        textConfig: {
          fontFamily: 'Goldman',
          text: '',
          fontSize: 28,
          align: 'left',
        },
        text: '',
        fontSize: 28,
      } as TextShapeDescriptor,
      config: {
        initialType: 'text',
      },
    });
  }

  addCommentShape(x: number, y: number) {
    return this.addNewShape({
      label: 'comment-shape',
      descriptor: {
        type: 'comment-shape',
        position: { x, y },
        svgAttributes: { fill: { color: '#000000' } },
        // TODO - clean this
        comments: [],
      } as CommentShapeDescriptor,
      config: {
        initial: true,
      },
    });
  }

  addGlowShape(x: number, y: number) {
    return this.addNewShape({
      label: 'glow-shape',
      descriptor: {
        type: 'glow-shape',
        position: { x, y },
        rx: 200,
        alpha: 0.5,
        ry: 200,
        svgAttributes: { fill: { color: '#ff0000' } },
        // TODO - clean this
      } as GlowShapeDescriptor,
      config: {
        initial: true,
      },
    });
  }

  getNewIRI() {
    return `http://nowords.com#${uuidv1()}`;
  }

  // getOffsetByPosition({ x, y }: ShapePosition) {
  //   const foundOffset =
  //     this.rootShape.storyboardController?.getOffsetByPosition(x, y);

  //   if (foundOffset) {
  //     const [offset, id] = foundOffset;
  //     const [ox, oy] = offset;
  //     return {
  //       relativePosition: [x - ox, y - oy],
  //       offset,
  //       id,
  //     };
  //   }
  // }

  addNewShape<T extends GeneralShape = GeneralShape>({
    label,
    descriptor,
    config,
    index,
    relationships,
    IRI,
  }: {
    label: string;
    descriptor: GeneralShapeDescriptor;
    config?: ShapeConfig;
    index?: number;
    relationships?: Relationships;
    IRI?: string;
  }): T {
    // TOOO - this should be smarter if we are zoomed mode //

    const lastShape =
      this.rootShape.shapesByIndex[this.rootShape.shapeIndexes.length - 1];
    index = lastShape ? lastShape.index + 1 : 0;
    if (isNaN(index)) {
      index = this.rootShape.shapes.length;
      // throw new Error(`Invalid index was about to be set: ${index}`);
    }

    config ||= {};

    config.isRoot = true;

    // const shapeOffset = this.getOffsetByPosition(descriptor.position);
    // if (shapeOffset) {
    //   const { relativePosition, offset, id } = shapeOffset;
    //   // -- // -- //
    //   const [x, y] = relativePosition;
    //   descriptor.isInStoryBoard = id;
    //   descriptor.position.x = x;
    //   descriptor.position.y = y;
    //   config.translateOffset = offset;
    // }

    descriptor.index = index;

    const resourceData = {
      IRI: IRI || this.getNewIRI(),
      type: 'nw:Shape',
      relationships: {
        file: this.rootShape.IRI,
        ...(relationships || {}),
      },
      literals: {
        label,
        descriptor,
      },
      // This is not elegant but practical
    };

    if (this.cs.currentAnimationID) {
      descriptor.animations ||= {};
      const animatItem: Record<string, AnimationItem> =
        descriptor.type == 'path-shape'
          ? {
              'path-fill': {
                key: 'path-fill',
                value: {
                  value: true,
                },
              },
            }
          : {
              'show-hide': {
                key: 'show-hide',
                value: {
                  value: true,
                },
              },
            };
      descriptor.animations[this.cs.currentAnimationID] = animatItem;
      console.warn('Adding animation to shape', resourceData.IRI);
    }

    // TODOx
    // This is because the path-shape offset is set and it would be readonly
    // This is not efficient
    // console.log('add-shape', resourceData);
    const shape = this.addNewShapeByResourceData<T>(resourceData, config);
    shape.select();

    if (this.cs.currentAnimationID) {
      this.store.dispatch(
        addAnimationItemAction({
          IRI: resourceData.IRI,
          item:
            descriptor.type == 'path-shape'
              ? {
                  key: 'path-fill',
                  value: {
                    value: true,
                  },
                }
              : {
                  key: 'show-hide',
                  value: {
                    value: true,
                  },
                },
        }),
      );
    }
    return shape;
  }

  addShapeByDescriptor<T extends GeneralShape = GeneralShape>(
    descriptor: GeneralShapeDescriptor,
  ) {
    return this.addNewShapesByDescriptor<T>([descriptor])[0];
  }

  addNewShapesByDescriptor<T extends GeneralShape = GeneralShape>(
    descriptors: GeneralShapeDescriptor[],
    masks: Record<string, number> = {},
  ): T[] {
    // -- //
    console.log(
      'addNewShapesByDescriptor',
      JSON.stringify(descriptors, null, 2),
    );
    let resourceData = descriptors.map((descriptor, index) => ({
      type: 'nw:Shape',
      IRI: `http://nowords.com#${uuidv1()}`,
      literals: {
        label: 'shape-' + index?.toString(),
        descriptor,
      },
      relationships: {
        parent: this.previewShape.IRI,
      },
    }));

    resourceData = resourceData.map(data => {
      const descriptor = data.literals.descriptor;
      descriptor.animations ||= {};
      if (descriptor.maskedBy) {
        descriptor.maskedBy = resourceData[masks[descriptor.maskedBy]].IRI;
      }

      if (this.cs.currentAnimationID) {
        const animatItem: Record<string, AnimationItem> =
          descriptor.type == 'path-shape'
            ? {
                'path-fill': {
                  key: 'path-fill',
                  value: {
                    value: true,
                  },
                },
              }
            : {
                'show-hide': {
                  key: 'show-hide',
                  value: {
                    value: true,
                  },
                },
              };

        descriptor.animations[this.cs.currentAnimation.id] = animatItem;

        console.log('add-animation-item > action', data.IRI);
        this.store.dispatch(
          addAnimationItemAction({
            IRI: data.IRI,
            item: Object.values(animatItem)[0],
          }),
        );
      }
      data.literals.descriptor = descriptor;

      return data;
    });

    const shapes = resourceData.map(resourceData =>
      this.addNewShapeByResourceData(resourceData),
    );

    shapes.forEach(shape => {
      if (shape.maskedBy) {
        const baseShape = (this.getResource(shape.maskedBy) ||
          this.getResource(
            this.previewShape.IRI + '_' + shape.maskedBy,
          )) as GeneralShape;
        baseShape.setMeAsMask(shape as GeneralShape, true);
      }
    });
    return shapes as T[];
  }

  addNewShapeByResourceData<T extends GeneralShape = GeneralShape>(
    resourceData: ResourceData,
    config?: ShapeConfig,
    noPush = false,
  ): T {
    resourceData.IRI ||= this.getNewIRI();
    // console.log('--------------- what what what --------------------');
    this.store.dispatch(addNewShapeAction({ data: cloneDeep(resourceData) }));
    // console.log('initShape', resourceData);
    const newShape = this.initShape<T>(resourceData, this.previewShape, config);

    if (!noPush) {
      this.rootShape._shapes.push(newShape);
    }
    newShape.afterInit();

    if (this.animationService.animationsByStart) {
      newShape.setAnimationMap(this.animationService.animationTimeMap, true);
    }

    return newShape;
  }

  _addNewShapeByResourceData<T extends GeneralShape = GeneralShape>(
    resourceData: ResourceData,
    config?: ShapeConfig,
  ): T {
    const newShape = this.initShape<T>(resourceData, this.previewShape, config);

    // this.shapes[resourceData.IRI] = newShape;
    this.store.dispatch(addNewShapeAction({ data: cloneDeep(resourceData) }));
    newShape.afterInit();
    return newShape;
  }

  copyShapes() {
    // -- //
  }

  pasteShapes() {
    // -- // -- // -- // -- //
  }

  addCopiedShape() {}

  saveImageToS3() {}

  createImportedShapeFromSelection() {
    if (!this.selectedShapes.length) {
      return alert('Please select at least one shape!');
    }

    const name = prompt('Please give a name to the new component');
    if (!name) {
      return;
    }
    const selectedShapes = this.selectedShapes;

    const IRI = this.getNewIRI();
    const { x, y, width, height } = this.getBoundingRectangle(selectedShapes);

    const offset = {
      ...this.cs.getAbsoluteCoords(x, y),
      width: width / this.cs.canvasScale,
      height: height / this.cs.canvasScale,
    };

    this.store.dispatch(
      createNewComponentAction({
        IRI,
        label: name,
        descriptor: {
          offset,
        },
      }),
    );
    //Its shapes are going to be set later

    // -- // -- // -- //
    const isIRI = this.getNewIRI();
    const is = this.addNewShapeByResourceData(
      {
        IRI: isIRI,
        type: 'nw:Shape',
        literals: {
          label: `${name}-instance`,
          descriptor: {
            index: this.previewShape.getNewShapeIndex(),
            type: 'imported-shape',
            position: {
              x: offset.x,
              y: offset.y,
            },
          },
        },
        relationships: {
          instanceOf: IRI,
          file: 'http://nowords.com#' + this.cs.currentFileID,
        },
      },
      {
        isRoot: true,
      },
    );

    this.selectedShapes.map(shape => {
      // console.log('delete-shape', shape);
      // this.store.dispatch(
      //   setShapeParent({
      //     IRI: shape.IRI,
      //     fileIRI: file.IRI,
      //   }),
      // );
      console.log('they will be reinitialized by the new instance');
      shape.remove();
    });
    this.deselectAllShapes();
    is.select();
    // -- // -- //
  }
}
